import { CompanySettings } from "../entities/CompanySettings";
import { SettingsRepository } from "../repositories/SettingsRepository";

/** Loads the Company Details form. */
export class GetCompanySettingsUseCase {
  constructor(private readonly repository: SettingsRepository) {}

  execute(signal?: AbortSignal): Promise<CompanySettings> {
    return this.repository.getCompanySettings(signal);
  }
}
